import React from "react";
import { Link } from "react-router-dom";

function Home() {
  const handelcopy = (e, bookingId) => {
    e.preventDefault();
    navigator.clipboard
      .writeText(bookingId)
      .then(() => {
        console.log("Booking ID copied to clipboard:", bookingId);
      })
      .catch((err) => {
        console.error("Failed to copy:", err);
      });
  };

  const carNumberhandelcopy = (e, CarNumber) => {
    e.preventDefault();
    navigator.clipboard
      .writeText(CarNumber)
      .then(() => {
        console.log("Car Number copied :", CarNumber);
      })
      .catch((err) => {
        console.error("Failed to copy:", err);
      });
  };
  return (
    <>
      <section className="itinerary-details section-padding">
        <div className="container-fluid">
          <div className="row plr-50">
            <div className="col-md-8">
              <h1 className="title">
                Your <span>Itinerary Details</span>
              </h1>
              <div className="bg-white left-side">
                <div className="left-side-title">
                  <img src="assets/img/title.png" alt="" />
                  <div className="left-side-title-content">
                    <h2>
                      Blusmart Cabs <span>Premium economy . AC . 4 Seats</span>
                    </h2>
                    <div>
                      <i className="fa-solid fa-car"></i> Tata Tiger or Similar
                    </div>
                  </div>
                </div>
                <div className="tracking-detail">
                  <div className="pickup-date-time">
                    <div className="pickup-date-title">
                      <h3>21, Feb 2025</h3>
                      <p>Pickup Date</p>
                    </div>
                    <ul className="progress-tracker">
                      <li>
                        <div className="step"></div>
                      </li>
                      <li className="complete">
                        <div className="step"></div>
                      </li>
                    </ul>
                    <div className="pickup-date-title text-right">
                      <h3>14:05</h3>
                      <p>Pickup Time</p>
                    </div>
                  </div>
                  <div className="adress-tracking">
                    <div className="adress-tracking-title">
                      <span>Premium</span>
                      <p>
                        Booking ID: XXXXXXXXXXX
                        <Link onClick={(e) => handelcopy(e, "XXXXXXXXXXX")}>
                          <i className="fa-regular fa-copy px-2"></i>
                        </Link>
                      </p>
                    </div>
                    <div className="location-container">
                      <div className="location">
                        <span className="location-icon"></span>
                        <div className="location-details">
                          <div className="location-name">Sector 14</div>
                          <div className="address">
                            A/73, phase 4, sector 14, Gurgaon, Haryana, India
                          </div>
                          <div className="time">PICK-UP: 10:00 AM</div>
                        </div>
                        <div className="connector"></div>
                      </div>
                      <div className="location">
                        <span className="location-icon">
                          <i className="fa-solid fa-location-dot"></i>
                        </span>
                        <div className="location-details">
                          <div className="location-name">T-2, IGI Airport</div>
                          <div className="address">
                            Terminal 1 C, departure, Indira Gandhi International
                            Airport Delhi
                          </div>
                          <div className="time">DROP: 12:05 PM</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="cab-location">
                  <div className="cab-location-title">
                    <h4>
                      Your Cab is <span>on the way</span>
                    </h4>
                    <p>
                      Pick up in <span>15:00Min</span>
                    </p>
                  </div>
                  <div className="driver-details">
                    <div className="row">
                      <div className="col-md-2 driver-img">
                        <img src="assets/img/cab-driver.jpg" alt="" />
                        <span>
                          <i className="fa-solid fa-star"></i> 4.2
                        </span>
                      </div>
                      <div className="col-md-5 driver-contact-detail">
                        <p>Ashish Vidyarthi</p>
                        <p>
                          Contact Number: <strong>+91 8914368679</strong>
                        </p>
                        <h5>HR55AG6942</h5>
                        <p>Maruti Suzuki Ciaz</p>
                        <p>OTP to start the ride</p>
                      </div>
                      <div className="col-md-5 pin-number-detail">
                        <Link
                          onClick={(e) => carNumberhandelcopy(e, "HR55AG6942")}
                        >
                          <i className="fa-regular fa-copy"></i>
                        </Link>
                        <div className="pin-number">
                          <ul>
                            <li>1</li>
                            <li>5</li>
                            <li>8</li>
                            <li>9</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="map">
                      <iframe
                        title="map"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3504.2133331715286!2d77.11775407549827!3d28.563355975702688!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1c615afd6eeb%3A0x11107cb14294d1bd!2sTerminal%201C%20%2F%20Domestic!5e0!3m2!1sen!2sin!4v1738260364360!5m2!1sen!2sin"
                        style={{ border: "0" }}
                        allowfullscreen=""
                        loading="lazy"
                        referrerpolicy="no-referrer-when-downgrade"
                      ></iframe>
                    </div>
                  </div>
                </div>
                <div className="trip-details">
                  <div className="details-box">
                    <div className="detail">
                      <i className="fa-regular fa-clock"></i>
                      <span>Free Cancellation</span>
                    </div>
                    <div className="detail">
                      <i className="fa-solid fa-chair"></i>
                      <span>4 Seats</span>
                    </div>
                    <div className="detail">
                      <i className="fa-solid fa-gauge"></i>
                      <span>Extra km Fare ₹11.5/km after 450km</span>
                    </div>
                  </div>
                  <div className="note">
                    <span>
                      Note: Details of the driver will be shared 40 minutes
                      before your trip starts.
                    </span>
                  </div>
                </div>
              </div>
              <div className="traveller-details-section">
                <h3 className="title-2">Traveller Detail</h3>
                <div className="traveller-details">
                  <div className="header" onclick="toggleAccordion()">
                    <div className="user-info">
                      <div className="initials">JD</div>
                      <div className="name-age">
                        <div className="name">John Doe (you)</div>
                        <div className="age-gender">Male | 28 year</div>
                      </div>
                    </div>
                    <div className="expand-icon">
                      <i className="fa-solid fa-angle-down"></i>
                    </div>
                  </div>
                  <div
                    className="accordion-content"
                    style={{ display: "none" }}
                  >
                    <div className="address">
                      <strong>Address:</strong> 123 Main Street, Anytown, CA
                      91234
                    </div>
                    <div className="phone">
                      <strong>Phone:</strong> (123) 456-7890
                    </div>
                  </div>
                </div>
              </div>
              <div className="traveller-details-section">
                <div className="traveller-details">
                  <div className="header">
                    <div className="user-info">
                      <div className="name-age">
                        <div className="name">Track your cab anytime</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <h1 className="title">
                Quick <span>Actions</span>
              </h1>
              <div className="quick-actions">
                <Link to="#">
                  <i className="fa-regular fa-envelope"></i>
                  Download
                </Link>
                <Link to="#">
                  <i className="fa-solid fa-share-nodes"></i>
                  Share
                </Link>
              </div>
              <div className="right-container">
                <div className="sidebar-block">
                  <div className="text-center">
                    <h2>BOOK YOUR RETURN</h2>
                    <h4>
                      Get rid of <span>Last Minute Rush</span>
                    </h4>
                  </div>
                  <div className="return-offer">
                    <img src="assets/img/car.jpg" alt="Return Offer" />
                    <div className="offer-details">
                      <p className="big-p">
                        Save up to 10% on <br />
                        uour return journey
                      </p>
                      <div className="offer-detail-link">
                        <div>
                          <p>Starting from</p>
                          <p className="offer-price">₹999 </p>
                        </div>
                        <Link to="">
                          <i className="fa-solid fa-arrow-up-long"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="help-section">
                  <h4>
                    Need help with <span>Your Booking?</span>
                  </h4>
                  <div className="help-options">
                    <div className="help-option">
                      <i className="fa-regular fa-message"></i>
                      <div>
                        <h6>
                          Contact Blue Smart: <Link to="">080070 05005</Link> or{" "}
                          <Link to="">info.blusmart@gmail.com</Link>
                        </h6>
                        <p>About any issue related to your booking</p>
                      </div>
                    </div>
                    <div className="help-option">
                      <i className="fa-solid fa-business-time"></i>
                      <div>
                        <h6>
                          Manage booking{" "}
                          <Link to="">
                            <span className="fa-solid fa-angle-right"></span>
                          </Link>
                        </h6>
                        <p>
                          Get to ' My trips' and manage <br />
                          your bookings
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="sidebar-block">
                  <h4 className="text-center">The Moko 6E Luggage</h4>
                  <div className="luggage-offer">
                    <img src="assets/img/add.jpg" alt="Luggage Offer" />
                    <div className="luggage-details offer-details">
                      <p className="big-p">
                        Moko 6E <br />
                        check-in luggage
                      </p>
                      <div className="offer-detail-link">
                        <div>
                          <p>Starting from</p>
                          <p className="offer-price">₹11,999 </p>
                        </div>
                        <Link to="">
                          <i className="fa-solid fa-arrow-up-long"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <h4>More information</h4>
                <div className="sidebar-block more-info">
                  <Link to="#">
                    <i className="fa-solid fa-file"></i>
                    BluSmart cab Faq
                  </Link>
                  <Link to="#">
                    <i className="fa-solid fa-file-invoice"></i>
                    Terms & Conditions
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;
